const SESSION_ACTION_TYPES = {
  SESSION_INITIALIZE: "session/SESSION_INITIALIZE",
  SESSION_SET_OFFLINE: "session/SESSION_SET_OFFLINE",
  SESSION_SET_ONLINE: "session/SESSION_SET_ONLINE",
  SESSION_RESET: "session/SESSION_RESET",
};

export default SESSION_ACTION_TYPES;
